import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/hde/banner_bg.webp";
import { Link } from "gatsby";

function Banner() {
  return (
    <section
      className="banner_hde"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={5} lg={4} xl={4} xxl={4} className="my-auto">
            <h1>High Def Events</h1>
            <p>
              HDE App is a one-stop digital auctions platform. It is a
              feature-packed mobile application with dedicated panels for
              creating appealing videos of products to intrigue the visitors
              into buying the product.
            </p>
          </Col>
          <Col
            xs={12}
            md={7}
            lg={7}
            xl={7}
            xxl={7}
            className="text-center offset-xl-1 offset-lg-1 my-auto"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/hde/banner_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={535}
                height={677}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
